import PropTypes from "prop-types"

import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const LineAddonPrice = ({ displayPrice, retailPrice, showSavings }) => {
  return (
    <div className="mb-12">
      {displayPrice == "0.0" ? (
        <p className="text-24 text-green-darker font-light">FREE</p>
      ) : (
        <>
          {showSavings && (
            <p className="text-sale text-10 tablet:text-16 tablet:leading-none font-bold leading-normal tracking-wider">
              SALE
            </p>
          )}
          <p
            className={cn(
              "text-30 font-light",
              displayPrice == retailPrice ? "text-sale" : "text-sale"
            )}
          >
            {to_currency(displayPrice)}
          </p>
        </>
      )}
      {showSavings && (
        <p className="text-grey-62 text-12 font-medium tracking-wide">
          <strike>{to_currency(retailPrice)}</strike>
          {/* <>
              RETAIL <strike>{to_currency(retailPrice)}</strike>
            </> */}
        </p>
      )}
    </div>
  )
}

LineAddonPrice.propTypes = {
  displayPrice: PropTypes.number,
  retailPrice: PropTypes.number,
  showSavings: PropTypes.bool,
}

export default LineAddonPrice
